import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SortControls = ({ sortBy, onSortChange, viewMode, onViewModeChange, resultsCount }) => {
  const sortOptions = [
    { value: 'relevance', label: 'İlgililik' },
    { value: 'followers-desc', label: 'Takipçi (Çoktan Aza)' },
    { value: 'followers-asc', label: 'Takipçi (Azdan Çoğa)' },
    { value: 'engagement-desc', label: 'Etkileşim (Yüksekten Düşüğe)' },
    { value: 'engagement-asc', label: 'Etkileşim (Düşükten Yükseğe)' },
    { value: 'price-desc', label: 'Fiyat (Yüksekten Düşüğe)' },
    { value: 'price-asc', label: 'Fiyat (Düşükten Yükseğe)' },
    { value: 'rating-desc', label: 'Değerlendirme (Yüksekten Düşüğe)' }
  ];

  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-3">
        <p className="text-sm text-muted-foreground">
          <span className="font-semibold text-foreground">{resultsCount}</span> influencer bulundu
        </p>
      </div>

      <div className="flex items-center gap-3">
        <div className="w-48">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Sırala"
          />
        </div>

        <div className="hidden md:flex items-center gap-1 bg-muted rounded-lg p-1">
          <Button
            variant={viewMode === 'grid' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('grid')}
            className="px-3"
          >
            <Icon name="Grid3x3" size={16} />
          </Button>
          <Button
            variant={viewMode === 'list' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('list')}
            className="px-3"
          >
            <Icon name="List" size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SortControls;